export enum LanguageEnum {
  English = 'English',
  German = 'German',
}

export namespace LanguageEnum {
  export const languages: LanguageEnum[] = [LanguageEnum.English, LanguageEnum.German];

  export const mapFromApiValue = (language: string): LanguageEnum => {
    switch (language) {
      case 'ENGLISH':
        return LanguageEnum.English;
      case 'GERMAN':
        return LanguageEnum.German;
      default:
        return LanguageEnum.English;
    }
  };

  export const mapToApiValue = (language: LanguageEnum): string => {
    switch (language) {
      case LanguageEnum.English:
        return 'ENGLISH';
      case LanguageEnum.German:
        return 'GERMAN';
      default:
        return 'ENGLISH';
    }
  };

  export const mapFromLanguageCode = (language: string): LanguageEnum => {
    switch (language) {
      case 'en':
        return LanguageEnum.English;
      case 'de':
        return LanguageEnum.German;
      default:
        return LanguageEnum.English;
    }
  };

  export const icon = (language?: LanguageEnum | null) => {
    switch (language) {
      case LanguageEnum.English:
        return "url('assets/images/languages/english.png')";
      case LanguageEnum.German:
        return "url('assets/images/languages/german.png')";
      default:
        return '';
    }
  };
  export const iconPath = (language?: LanguageEnum | null) => {
    switch (language) {
      case LanguageEnum.English:
        return 'assets/images/languages/english.png';
      case LanguageEnum.German:
        return 'assets/images/languages/german.png';
      default:
        return '';
    }
  };

  export const name = (language?: LanguageEnum | null) => {
    switch (language) {
      case LanguageEnum.English:
        return 'common.languages.english';
      case LanguageEnum.German:
        return 'common.languages.german';
      default:
        return '';
    }
  };

  export const code = (language: LanguageEnum) => {
    switch (language) {
      case LanguageEnum.English:
        return 'en';
      case LanguageEnum.German:
        return 'de';
      default:
        return 'en';
    }
  };
}
